import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';
import * as systemActionTypes from '../../system/action-creator/actionTypes';

import { ERROR_TYPE_NOT_CONNECTED, ERROR_TYPE_NO_ERROR } from '../constants';

const errorTypes = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ERROR_TYPES_SUCCESS:
      return action.errorTypes;
    default:
      return state;
  }
}

const offlineIntervalId = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.START_OFFLINE_INTERVAL:
      return action.id;
    case actionTypes.STOP_OFFLINE_INTERVAL:
      return 0;
    default:
      return state;
  }
}

const byStationId = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LATEST_DATA_SUCCESS:
    case actionTypes.SET_HEALTH_DATA:
    case actionTypes.SET_INITIAL_HEALTH_DATA:
      return {
        ...state,
        ...action.byId
      };
    case actionTypes.SET_STATION_ERROR_TYPE:
      return {
        ...state,
        [action.stationId]: {
          ...state[action.stationId],
          errorType: action.errorType
        }
      };
    case systemActionTypes.LOGOUT_REQUEST:
      return {};
    default:
      return state;
  }
};

const stationIds = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SET_INITIAL_HEALTH_DATA:
      return action.ids;
    case systemActionTypes.LOGOUT_REQUEST:
      return [];
    default:
      return state;
  }
}

const selectedStationId = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_STATION:
      return action.stationId;
    default:
      return state;
  }
}

const filterId = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.FILTER_STATUS:
      return action.filterId;
    default:
      return state;
  }
}

const isSearching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LATEST_DATA_REQUEST:
      return true;
    case actionTypes.FETCH_LATEST_DATA_SUCCESS:
    case actionTypes.FETCH_LATEST_DATA_FAILURE:
      return false;
    default:
      return state;
  }
}

const latestPR = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_PR_DATA:  // Handle SET_PR_DATA action
      return {
        ...state,
        ...action.byId
      };
    case actionTypes.CLEAR_PR_DATA:
      return {};  // Reset the heatmap data
    default:
      return state;
  }
};

export default combineReducers({
  byStationId,
  latestPR,
  filterId,
  offlineIntervalId,
  stationIds,
  errorTypes,
  selectedStationId,
  isSearching
});

const getCurrentState = state => state.healthData;

export const getByStationId = state => getCurrentState(state).byStationId;

export const getLiveHealthDataList = state => {
  const { byStationId, stationIds } = getCurrentState(state);
  return stationIds.map(stationId => byStationId[stationId]);
}

export const getErrorTypeList = state => {
  const { byStationId, stationIds } = getCurrentState(state);
  const filterErrorType = [0];
  stationIds.map(stationId => (filterErrorType.includes(byStationId[stationId].errorType)) ? false : filterErrorType.push(byStationId[stationId].errorType));

  return filterErrorType;
}

export const getHealthSummary = state => {
  const { byStationId } = getCurrentState(state);
  var notConnected = 0;
  var noError = 0;
  var error = 0;
  for (var key in byStationId) {
    switch (byStationId[key].errorType) {
      case ERROR_TYPE_NOT_CONNECTED:
        notConnected++;
        break;
      case ERROR_TYPE_NO_ERROR:
        noError++;
        break;
      default:
        error++;
        break;
    }
  }

  return {
    notConnected,
    noError,
    error
  }
}

export const getOfflineIntervalId = state => getCurrentState(state).offlineIntervalId;

export const getErrorTypes = state => getCurrentState(state).errorTypes;

export const getFilterStatusId = state => getCurrentState(state).filterId;

export const getSelectionId = state => getCurrentState(state).selectedStationId;

export const getSelectedStationHealth = state => {
  const { byStationId, selectedStationId } = getCurrentState(state);
  return selectedStationId ? byStationId[selectedStationId] : null;
}

export const getIsSearching = state => getCurrentState(state).isSearching;

export const getLatestPR = state => getCurrentState(state).latestPR;